export const OCCUPATION_ATTRIBUTES = [
  {
    "code": "11-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 6.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.63
      }
    ]
  },
  {
    "code": "11-1011.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.89
      }
    ]
  },
  {
    "code": "11-1021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.07
      }
    ]
  },
  {
    "code": "11-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.55
      }
    ]
  },
  {
    "code": "11-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.4
      }
    ]
  },
  {
    "code": "11-2022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 5.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.22
      }
    ]
  },
  {
    "code": "11-3012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.54
      }
    ]
  },
  {
    "code": "11-3013.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.3
      }
    ]
  },
  {
    "code": "11-3021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.67
      }
    ]
  },
  {
    "code": "11-3031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 5.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.48
      }
    ]
  },
  {
    "code": "11-3031.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 5.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.13
      }
    ]
  },
  {
    "code": "11-3031.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.46
      }
    ]
  },
  {
    "code": "11-3051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.74
      }
    ]
  },
  {
    "code": "11-3051.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.2
      }
    ]
  },
  {
    "code": "11-3051.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.63
      }
    ]
  },
  {
    "code": "11-3051.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.46
      }
    ]
  },
  {
    "code": "11-3051.04",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.39
      }
    ]
  },
  {
    "code": "11-3051.06",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.2
      }
    ]
  },
  {
    "code": "11-3061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.05
      }
    ]
  },
  {
    "code": "11-3071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.35
      }
    ]
  },
  {
    "code": "11-3071.04",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.38
      }
    ]
  },
  {
    "code": "11-3111.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.33
      }
    ]
  },
  {
    "code": "11-3121.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.71
      }
    ]
  },
  {
    "code": "11-3131.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.54
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.71
      }
    ]
  },
  {
    "code": "11-9013.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.35
      }
    ]
  },
  {
    "code": "11-9021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.05
      }
    ]
  },
  {
    "code": "11-9031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.34
      }
    ]
  },
  {
    "code": "11-9032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.95
      }
    ]
  },
  {
    "code": "11-9033.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.97
      }
    ]
  },
  {
    "code": "11-9041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.91
      }
    ]
  },
  {
    "code": "11-9041.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.91
      }
    ]
  },
  {
    "code": "11-9051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.39
      }
    ]
  },
  {
    "code": "11-9071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.32
      }
    ]
  },
  {
    "code": "11-9081.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.91
      }
    ]
  },
  {
    "code": "11-9111.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 5.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.36
      }
    ]
  },
  {
    "code": "11-9121.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.5
      }
    ]
  },
  {
    "code": "11-9121.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.07
      }
    ]
  },
  {
    "code": "11-9121.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.45
      }
    ]
  },
  {
    "code": "11-9131.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.11
      }
    ]
  },
  {
    "code": "11-9141.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 5.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.2
      }
    ]
  },
  {
    "code": "11-9151.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.06
      }
    ]
  },
  {
    "code": "11-9161.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.5
      }
    ]
  },
  {
    "code": "11-9171.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 5.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.71
      }
    ]
  },
  {
    "code": "11-9179.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.36
      }
    ]
  },
  {
    "code": "11-9179.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.08
      }
    ]
  },
  {
    "code": "11-9199.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.35
      }
    ]
  },
  {
    "code": "11-9199.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.73
      }
    ]
  },
  {
    "code": "11-9199.08",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.14
      }
    ]
  },
  {
    "code": "11-9199.09",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 5.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.08
      }
    ]
  },
  {
    "code": "11-9199.10",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.1
      }
    ]
  },
  {
    "code": "11-9199.11",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.33
      }
    ]
  },
  {
    "code": "13-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.57
      }
    ]
  },
  {
    "code": "13-1021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.62
      }
    ]
  },
  {
    "code": "13-1022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.15
      }
    ]
  },
  {
    "code": "13-1023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.35
      }
    ]
  },
  {
    "code": "13-1031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.66
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.75
      }
    ]
  },
  {
    "code": "13-1032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.63
      }
    ]
  },
  {
    "code": "13-1041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.92
      }
    ]
  },
  {
    "code": "13-1041.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.75
      }
    ]
  },
  {
    "code": "13-1041.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.5
      }
    ]
  },
  {
    "code": "13-1041.04",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.21
      }
    ]
  },
  {
    "code": "13-1041.06",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.95
      }
    ]
  },
  {
    "code": "13-1041.07",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.45
      }
    ]
  },
  {
    "code": "13-1041.08",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.8
      }
    ]
  },
  {
    "code": "13-1051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.73
      }
    ]
  },
  {
    "code": "13-1071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.53
      }
    ]
  },
  {
    "code": "13-1074.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.47
      }
    ]
  },
  {
    "code": "13-1075.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.45
      }
    ]
  },
  {
    "code": "13-1081.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 5.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.54
      }
    ]
  },
  {
    "code": "13-1081.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.89
      }
    ]
  },
  {
    "code": "13-1081.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.95
      }
    ]
  },
  {
    "code": "13-1111.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.57
      }
    ]
  },
  {
    "code": "13-1121.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.03
      }
    ]
  },
  {
    "code": "13-1131.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.86
      }
    ]
  },
  {
    "code": "13-1141.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.9
      }
    ]
  },
  {
    "code": "13-1151.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.83
      }
    ]
  },
  {
    "code": "13-1161.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.13
      }
    ]
  },
  {
    "code": "13-1161.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.3
      }
    ]
  },
  {
    "code": "13-1199.04",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.05
      }
    ]
  },
  {
    "code": "13-1199.05",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.61
      }
    ]
  },
  {
    "code": "13-1199.06",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.78
      }
    ]
  },
  {
    "code": "13-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.92
      }
    ]
  },
  {
    "code": "13-2023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.26
      }
    ]
  },
  {
    "code": "13-2031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.52
      }
    ]
  },
  {
    "code": "13-2041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.75
      }
    ]
  },
  {
    "code": "13-2052.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.58
      }
    ]
  },
  {
    "code": "13-2053.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.97
      }
    ]
  },
  {
    "code": "13-2061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.17
      }
    ]
  },
  {
    "code": "13-2071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.76
      }
    ]
  },
  {
    "code": "13-2072.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.2
      }
    ]
  },
  {
    "code": "13-2081.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.85
      }
    ]
  },
  {
    "code": "13-2082.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.05
      }
    ]
  },
  {
    "code": "13-2099.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 6.05
      }
    ]
  },
  {
    "code": "13-2099.04",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.6
      }
    ]
  },
  {
    "code": "15-1211.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.76
      }
    ]
  },
  {
    "code": "15-1211.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.14
      }
    ]
  },
  {
    "code": "15-1212.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.53
      }
    ]
  },
  {
    "code": "15-1221.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.43
      }
    ]
  },
  {
    "code": "15-1231.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.08
      }
    ]
  },
  {
    "code": "15-1232.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.28
      }
    ]
  },
  {
    "code": "15-1241.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.7
      }
    ]
  },
  {
    "code": "15-1241.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.19
      }
    ]
  },
  {
    "code": "15-1242.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.63
      }
    ]
  },
  {
    "code": "15-1243.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.81
      }
    ]
  },
  {
    "code": "15-1243.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.55
      }
    ]
  },
  {
    "code": "15-1244.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.77
      }
    ]
  },
  {
    "code": "15-1251.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.54
      }
    ]
  },
  {
    "code": "15-1253.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.24
      }
    ]
  },
  {
    "code": "15-1254.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.91
      }
    ]
  },
  {
    "code": "15-1255.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.8
      }
    ]
  },
  {
    "code": "15-1299.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.65
      }
    ]
  },
  {
    "code": "15-1299.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.88
      }
    ]
  },
  {
    "code": "15-1299.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.65
      }
    ]
  },
  {
    "code": "15-1299.08",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.71
      }
    ]
  },
  {
    "code": "15-1299.09",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.95
      }
    ]
  },
  {
    "code": "15-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 6.36
      }
    ]
  },
  {
    "code": "15-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 6
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 6.83
      }
    ]
  },
  {
    "code": "15-2031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 6.43
      }
    ]
  },
  {
    "code": "15-2041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 6.24
      }
    ]
  },
  {
    "code": "15-2041.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.83
      }
    ]
  },
  {
    "code": "15-2051.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.67
      }
    ]
  },
  {
    "code": "15-2051.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.85
      }
    ]
  },
  {
    "code": "15-2099.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.99
      }
    ]
  },
  {
    "code": "17-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.14
      }
    ]
  },
  {
    "code": "17-1012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.54
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.25
      }
    ]
  },
  {
    "code": "17-1021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.25
      }
    ]
  },
  {
    "code": "17-1022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.5
      }
    ]
  },
  {
    "code": "17-1022.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.74
      }
    ]
  },
  {
    "code": "17-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.57
      }
    ]
  },
  {
    "code": "17-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.9
      }
    ]
  },
  {
    "code": "17-2031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.52
      }
    ]
  },
  {
    "code": "17-2041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.86
      }
    ]
  },
  {
    "code": "17-2051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.1
      }
    ]
  },
  {
    "code": "17-2051.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.05
      }
    ]
  },
  {
    "code": "17-2051.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.13
      }
    ]
  },
  {
    "code": "17-2061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.54
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.72
      }
    ]
  },
  {
    "code": "17-2071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.01
      }
    ]
  },
  {
    "code": "17-2072.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.54
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.38
      }
    ]
  },
  {
    "code": "17-2072.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.32
      }
    ]
  },
  {
    "code": "17-2081.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.24
      }
    ]
  },
  {
    "code": "17-2111.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.63
      }
    ]
  },
  {
    "code": "17-2111.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.1
      }
    ]
  },
  {
    "code": "17-2112.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.86
      }
    ]
  },
  {
    "code": "17-2112.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.35
      }
    ]
  },
  {
    "code": "17-2112.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.85
      }
    ]
  },
  {
    "code": "17-2112.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.12
      }
    ]
  },
  {
    "code": "17-2121.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.48
      }
    ]
  },
  {
    "code": "17-2131.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.35
      }
    ]
  },
  {
    "code": "17-2141.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.8
      }
    ]
  },
  {
    "code": "17-2141.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.14
      }
    ]
  },
  {
    "code": "17-2141.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.52
      }
    ]
  },
  {
    "code": "17-2151.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.19
      }
    ]
  },
  {
    "code": "17-2161.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.71
      }
    ]
  },
  {
    "code": "17-2171.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.02
      }
    ]
  },
  {
    "code": "17-2199.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.91
      }
    ]
  },
  {
    "code": "17-2199.05",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.67
      }
    ]
  },
  {
    "code": "17-2199.06",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.65
      }
    ]
  },
  {
    "code": "17-2199.07",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.74
      }
    ]
  },
  {
    "code": "17-2199.08",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.5
      }
    ]
  },
  {
    "code": "17-2199.09",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.52
      }
    ]
  },
  {
    "code": "17-2199.10",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.52
      }
    ]
  },
  {
    "code": "17-2199.11",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.5
      }
    ]
  },
  {
    "code": "17-3011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.12
      }
    ]
  },
  {
    "code": "17-3012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.49
      }
    ]
  },
  {
    "code": "17-3013.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.84
      }
    ]
  },
  {
    "code": "17-3021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.84
      }
    ]
  },
  {
    "code": "17-3022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.93
      }
    ]
  },
  {
    "code": "17-3023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.39
      }
    ]
  },
  {
    "code": "17-3024.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.86
      }
    ]
  },
  {
    "code": "17-3024.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.86
      }
    ]
  },
  {
    "code": "17-3025.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.59
      }
    ]
  },
  {
    "code": "17-3026.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.9
      }
    ]
  },
  {
    "code": "17-3026.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.54
      }
    ]
  },
  {
    "code": "17-3027.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.66
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.14
      }
    ]
  },
  {
    "code": "17-3027.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.59
      }
    ]
  },
  {
    "code": "17-3029.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.73
      }
    ]
  },
  {
    "code": "17-3029.08",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.27
      }
    ]
  },
  {
    "code": "17-3031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.66
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.28
      }
    ]
  },
  {
    "code": "19-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.48
      }
    ]
  },
  {
    "code": "19-1012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.48
      }
    ]
  },
  {
    "code": "19-1013.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.14
      }
    ]
  },
  {
    "code": "19-1021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.8
      }
    ]
  },
  {
    "code": "19-1022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.23
      }
    ]
  },
  {
    "code": "19-1023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.03
      }
    ]
  },
  {
    "code": "19-1029.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.5
      }
    ]
  },
  {
    "code": "19-1029.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.96
      }
    ]
  },
  {
    "code": "19-1029.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.64
      }
    ]
  },
  {
    "code": "19-1029.04",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.97
      }
    ]
  },
  {
    "code": "19-1031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.7
      }
    ]
  },
  {
    "code": "19-1031.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.74
      }
    ]
  },
  {
    "code": "19-1031.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.95
      }
    ]
  },
  {
    "code": "19-1032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.21
      }
    ]
  },
  {
    "code": "19-1041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.32
      }
    ]
  },
  {
    "code": "19-1042.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.33
      }
    ]
  },
  {
    "code": "19-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 6.43
      }
    ]
  },
  {
    "code": "19-2012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 5.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 5.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 5.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 6.59
      }
    ]
  },
  {
    "code": "19-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 6
      }
    ]
  },
  {
    "code": "19-2031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.55
      }
    ]
  },
  {
    "code": "19-2032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.71
      }
    ]
  },
  {
    "code": "19-2041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.31
      }
    ]
  },
  {
    "code": "19-2041.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.39
      }
    ]
  },
  {
    "code": "19-2041.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.36
      }
    ]
  },
  {
    "code": "19-2041.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.48
      }
    ]
  },
  {
    "code": "19-2042.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.81
      }
    ]
  },
  {
    "code": "19-2043.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.78
      }
    ]
  },
  {
    "code": "19-2099.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.4
      }
    ]
  },
  {
    "code": "19-3011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.54
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 6.08
      }
    ]
  },
  {
    "code": "19-3011.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 6.26
      }
    ]
  },
  {
    "code": "19-3022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.96
      }
    ]
  },
  {
    "code": "19-3032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.92
      }
    ]
  },
  {
    "code": "19-3033.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.08
      }
    ]
  },
  {
    "code": "19-3034.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.32
      }
    ]
  },
  {
    "code": "19-3039.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.32
      }
    ]
  },
  {
    "code": "19-3039.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.71
      }
    ]
  },
  {
    "code": "19-3041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.75
      }
    ]
  },
  {
    "code": "19-3051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.25
      }
    ]
  },
  {
    "code": "19-3091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.2
      }
    ]
  },
  {
    "code": "19-3092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.1
      }
    ]
  },
  {
    "code": "19-3093.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.79
      }
    ]
  },
  {
    "code": "19-3094.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.73
      }
    ]
  },
  {
    "code": "19-3099.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.9
      }
    ]
  },
  {
    "code": "19-4012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.57
      }
    ]
  },
  {
    "code": "19-4012.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.39
      }
    ]
  },
  {
    "code": "19-4013.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.67
      }
    ]
  },
  {
    "code": "19-4021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.55
      }
    ]
  },
  {
    "code": "19-4031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.62
      }
    ]
  },
  {
    "code": "19-4042.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4
      }
    ]
  },
  {
    "code": "19-4043.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.43
      }
    ]
  },
  {
    "code": "19-4051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.75
      }
    ]
  },
  {
    "code": "19-4051.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.3
      }
    ]
  },
  {
    "code": "19-4061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.07
      }
    ]
  },
  {
    "code": "19-4071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.8
      }
    ]
  },
  {
    "code": "19-4092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.54
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.02
      }
    ]
  },
  {
    "code": "19-4099.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.58
      }
    ]
  },
  {
    "code": "19-4099.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.48
      }
    ]
  },
  {
    "code": "19-5011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.43
      }
    ]
  },
  {
    "code": "19-5012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.62
      }
    ]
  },
  {
    "code": "21-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.74
      }
    ]
  },
  {
    "code": "21-1012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.43
      }
    ]
  },
  {
    "code": "21-1013.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.41
      }
    ]
  },
  {
    "code": "21-1014.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.18
      }
    ]
  },
  {
    "code": "21-1015.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.83
      }
    ]
  },
  {
    "code": "21-1021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.32
      }
    ]
  },
  {
    "code": "21-1022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.85
      }
    ]
  },
  {
    "code": "21-1023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.6
      }
    ]
  },
  {
    "code": "21-1091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.22
      }
    ]
  },
  {
    "code": "21-1092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.84
      }
    ]
  },
  {
    "code": "21-1093.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.89
      }
    ]
  },
  {
    "code": "21-1094.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.66
      }
    ]
  },
  {
    "code": "21-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.33
      }
    ]
  },
  {
    "code": "21-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.73
      }
    ]
  },
  {
    "code": "23-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.32
      }
    ]
  },
  {
    "code": "23-1012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.15
      }
    ]
  },
  {
    "code": "23-1021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.41
      }
    ]
  },
  {
    "code": "23-1022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.3
      }
    ]
  },
  {
    "code": "23-1023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.52
      }
    ]
  },
  {
    "code": "23-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.81
      }
    ]
  },
  {
    "code": "23-2093.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.17
      }
    ]
  },
  {
    "code": "25-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 5.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.5
      }
    ]
  },
  {
    "code": "25-1021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.76
      }
    ]
  },
  {
    "code": "25-1022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 6.51
      }
    ]
  },
  {
    "code": "25-1031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.92
      }
    ]
  },
  {
    "code": "25-1032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.9
      }
    ]
  },
  {
    "code": "25-1041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.62
      }
    ]
  },
  {
    "code": "25-1042.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.99
      }
    ]
  },
  {
    "code": "25-1043.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.62
      }
    ]
  },
  {
    "code": "25-1051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.55
      }
    ]
  },
  {
    "code": "25-1052.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.54
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.65
      }
    ]
  },
  {
    "code": "25-1053.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.06
      }
    ]
  },
  {
    "code": "25-1054.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 6.52
      }
    ]
  },
  {
    "code": "25-1061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.09
      }
    ]
  },
  {
    "code": "25-1062.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.11
      }
    ]
  },
  {
    "code": "25-1063.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.54
      }
    ]
  },
  {
    "code": "25-1064.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.16
      }
    ]
  },
  {
    "code": "25-1065.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.27
      }
    ]
  },
  {
    "code": "25-1066.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.96
      }
    ]
  },
  {
    "code": "25-1067.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.66
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.87
      }
    ]
  },
  {
    "code": "25-1071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.93
      }
    ]
  },
  {
    "code": "25-1072.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.36
      }
    ]
  },
  {
    "code": "25-1081.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.29
      }
    ]
  },
  {
    "code": "25-1082.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.79
      }
    ]
  },
  {
    "code": "25-1111.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.73
      }
    ]
  },
  {
    "code": "25-1112.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.86
      }
    ]
  },
  {
    "code": "25-1113.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.56
      }
    ]
  },
  {
    "code": "25-1121.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.59
      }
    ]
  },
  {
    "code": "25-1122.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.27
      }
    ]
  },
  {
    "code": "25-1123.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.22
      }
    ]
  },
  {
    "code": "25-1124.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.66
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.69
      }
    ]
  },
  {
    "code": "25-1125.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.12
      }
    ]
  },
  {
    "code": "25-1126.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.67
      }
    ]
  },
  {
    "code": "25-1192.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.13
      }
    ]
  },
  {
    "code": "25-1193.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.32
      }
    ]
  },
  {
    "code": "25-1194.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.38
      }
    ]
  },
  {
    "code": "25-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.66
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.92
      }
    ]
  },
  {
    "code": "25-2012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.55
      }
    ]
  },
  {
    "code": "25-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.66
      }
    ]
  },
  {
    "code": "25-2022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.66
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.2
      }
    ]
  },
  {
    "code": "25-2023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.44
      }
    ]
  },
  {
    "code": "25-2031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.69
      }
    ]
  },
  {
    "code": "25-2032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.02
      }
    ]
  },
  {
    "code": "25-2051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.79
      }
    ]
  },
  {
    "code": "25-2057.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.92
      }
    ]
  },
  {
    "code": "25-2058.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.16
      }
    ]
  },
  {
    "code": "25-2059.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.62
      }
    ]
  },
  {
    "code": "25-3011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3
      }
    ]
  },
  {
    "code": "25-3021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.28
      }
    ]
  },
  {
    "code": "25-3041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.64
      }
    ]
  },
  {
    "code": "25-4011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.81
      }
    ]
  },
  {
    "code": "25-4012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.46
      }
    ]
  },
  {
    "code": "25-4013.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.18
      }
    ]
  },
  {
    "code": "25-4022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.95
      }
    ]
  },
  {
    "code": "25-4031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.45
      }
    ]
  },
  {
    "code": "25-9021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.93
      }
    ]
  },
  {
    "code": "25-9031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.69
      }
    ]
  },
  {
    "code": "25-9042.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.36
      }
    ]
  },
  {
    "code": "25-9044.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.71
      }
    ]
  },
  {
    "code": "27-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.14
      }
    ]
  },
  {
    "code": "27-1012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.32
      }
    ]
  },
  {
    "code": "27-1013.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.52
      }
    ]
  },
  {
    "code": "27-1014.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3
      }
    ]
  },
  {
    "code": "27-1021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.24
      }
    ]
  },
  {
    "code": "27-1022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.55
      }
    ]
  },
  {
    "code": "27-1023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.22
      }
    ]
  },
  {
    "code": "27-1024.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.74
      }
    ]
  },
  {
    "code": "27-1025.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.43
      }
    ]
  },
  {
    "code": "27-1026.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.5
      }
    ]
  },
  {
    "code": "27-1027.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.19
      }
    ]
  },
  {
    "code": "27-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.38
      }
    ]
  },
  {
    "code": "27-2012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2
      }
    ]
  },
  {
    "code": "27-2012.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.45
      }
    ]
  },
  {
    "code": "27-2012.04",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.25
      }
    ]
  },
  {
    "code": "27-2012.05",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.64
      }
    ]
  },
  {
    "code": "27-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.14
      }
    ]
  },
  {
    "code": "27-2022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.32
      }
    ]
  },
  {
    "code": "27-2023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.95
      }
    ]
  },
  {
    "code": "27-2031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.67
      }
    ]
  },
  {
    "code": "27-2032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.71
      }
    ]
  },
  {
    "code": "27-2041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.16
      }
    ]
  },
  {
    "code": "27-2042.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.9
      }
    ]
  },
  {
    "code": "27-3011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.93
      }
    ]
  },
  {
    "code": "27-3023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.88
      }
    ]
  },
  {
    "code": "27-3031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.91
      }
    ]
  },
  {
    "code": "27-3041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.66
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.83
      }
    ]
  },
  {
    "code": "27-3042.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.36
      }
    ]
  },
  {
    "code": "27-3043.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.66
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.55
      }
    ]
  },
  {
    "code": "27-3043.05",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1
      }
    ]
  },
  {
    "code": "27-3091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.53
      }
    ]
  },
  {
    "code": "27-3092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.39
      }
    ]
  },
  {
    "code": "27-4011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.09
      }
    ]
  },
  {
    "code": "27-4012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.85
      }
    ]
  },
  {
    "code": "27-4014.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.19
      }
    ]
  },
  {
    "code": "27-4021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.86
      }
    ]
  },
  {
    "code": "27-4031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.73
      }
    ]
  },
  {
    "code": "27-4032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.08
      }
    ]
  },
  {
    "code": "29-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.4
      }
    ]
  },
  {
    "code": "29-1021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.34
      }
    ]
  },
  {
    "code": "29-1022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.31
      }
    ]
  },
  {
    "code": "29-1023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.37
      }
    ]
  },
  {
    "code": "29-1024.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.3
      }
    ]
  },
  {
    "code": "29-1031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.27
      }
    ]
  },
  {
    "code": "29-1041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.1
      }
    ]
  },
  {
    "code": "29-1051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.41
      }
    ]
  },
  {
    "code": "29-1071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.76
      }
    ]
  },
  {
    "code": "29-1071.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.53
      }
    ]
  },
  {
    "code": "29-1081.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.91
      }
    ]
  },
  {
    "code": "29-1122.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.5
      }
    ]
  },
  {
    "code": "29-1122.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.91
      }
    ]
  },
  {
    "code": "29-1123.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.08
      }
    ]
  },
  {
    "code": "29-1124.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.84
      }
    ]
  },
  {
    "code": "29-1125.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.27
      }
    ]
  },
  {
    "code": "29-1126.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.69
      }
    ]
  },
  {
    "code": "29-1127.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.87
      }
    ]
  },
  {
    "code": "29-1128.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.68
      }
    ]
  },
  {
    "code": "29-1129.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.91
      }
    ]
  },
  {
    "code": "29-1129.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.5
      }
    ]
  },
  {
    "code": "29-1131.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.2
      }
    ]
  },
  {
    "code": "29-1141.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.4
      }
    ]
  },
  {
    "code": "29-1141.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.71
      }
    ]
  },
  {
    "code": "29-1141.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.91
      }
    ]
  },
  {
    "code": "29-1141.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.04
      }
    ]
  },
  {
    "code": "29-1141.04",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.07
      }
    ]
  },
  {
    "code": "29-1151.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.88
      }
    ]
  },
  {
    "code": "29-1161.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.61
      }
    ]
  },
  {
    "code": "29-1171.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.96
      }
    ]
  },
  {
    "code": "29-1181.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.59
      }
    ]
  },
  {
    "code": "29-1211.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.59
      }
    ]
  },
  {
    "code": "29-1213.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.25
      }
    ]
  },
  {
    "code": "29-1215.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.38
      }
    ]
  },
  {
    "code": "29-1216.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.42
      }
    ]
  },
  {
    "code": "29-1217.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.49
      }
    ]
  },
  {
    "code": "29-1218.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.58
      }
    ]
  },
  {
    "code": "29-1221.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.09
      }
    ]
  },
  {
    "code": "29-1222.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3
      }
    ]
  },
  {
    "code": "29-1223.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.03
      }
    ]
  },
  {
    "code": "29-1224.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.56
      }
    ]
  },
  {
    "code": "29-1229.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.72
      }
    ]
  },
  {
    "code": "29-1229.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.58
      }
    ]
  },
  {
    "code": "29-1229.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 5.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.09
      }
    ]
  },
  {
    "code": "29-1229.04",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.96
      }
    ]
  },
  {
    "code": "29-1229.05",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.58
      }
    ]
  },
  {
    "code": "29-1229.06",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.48
      }
    ]
  },
  {
    "code": "29-1241.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.11
      }
    ]
  },
  {
    "code": "29-1291.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.02
      }
    ]
  },
  {
    "code": "29-1292.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.77
      }
    ]
  },
  {
    "code": "29-1299.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 5.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.4
      }
    ]
  },
  {
    "code": "29-1299.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.29
      }
    ]
  },
  {
    "code": "29-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.56
      }
    ]
  },
  {
    "code": "29-2011.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.71
      }
    ]
  },
  {
    "code": "29-2011.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.55
      }
    ]
  },
  {
    "code": "29-2011.04",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.81
      }
    ]
  },
  {
    "code": "29-2012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.13
      }
    ]
  },
  {
    "code": "29-2031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.3
      }
    ]
  },
  {
    "code": "29-2032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.17
      }
    ]
  },
  {
    "code": "29-2033.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.03
      }
    ]
  },
  {
    "code": "29-2034.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.15
      }
    ]
  },
  {
    "code": "29-2035.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.91
      }
    ]
  },
  {
    "code": "29-2036.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.6
      }
    ]
  },
  {
    "code": "29-2051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.63
      }
    ]
  },
  {
    "code": "29-2052.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.64
      }
    ]
  },
  {
    "code": "29-2053.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.4
      }
    ]
  },
  {
    "code": "29-2055.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.2
      }
    ]
  },
  {
    "code": "29-2056.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.63
      }
    ]
  },
  {
    "code": "29-2057.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.09
      }
    ]
  },
  {
    "code": "29-2061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.11
      }
    ]
  },
  {
    "code": "29-2081.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.54
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.08
      }
    ]
  },
  {
    "code": "29-2091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4
      }
    ]
  },
  {
    "code": "29-2092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.72
      }
    ]
  },
  {
    "code": "29-2099.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.32
      }
    ]
  },
  {
    "code": "29-2099.05",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.25
      }
    ]
  },
  {
    "code": "29-2099.08",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.93
      }
    ]
  },
  {
    "code": "29-9091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.71
      }
    ]
  },
  {
    "code": "29-9092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.52
      }
    ]
  },
  {
    "code": "29-9093.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.77
      }
    ]
  },
  {
    "code": "29-9099.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.94
      }
    ]
  },
  {
    "code": "31-1121.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.61
      }
    ]
  },
  {
    "code": "31-1122.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.19
      }
    ]
  },
  {
    "code": "31-1131.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.95
      }
    ]
  },
  {
    "code": "31-1132.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 0.65
      }
    ]
  },
  {
    "code": "31-1133.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.47
      }
    ]
  },
  {
    "code": "31-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.62
      }
    ]
  },
  {
    "code": "31-2012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.6
      }
    ]
  },
  {
    "code": "31-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.52
      }
    ]
  },
  {
    "code": "31-2022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.09
      }
    ]
  },
  {
    "code": "31-9011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.04
      }
    ]
  },
  {
    "code": "31-9091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.41
      }
    ]
  },
  {
    "code": "31-9092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.84
      }
    ]
  },
  {
    "code": "31-9093.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.55
      }
    ]
  },
  {
    "code": "31-9094.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.52
      }
    ]
  },
  {
    "code": "31-9095.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.24
      }
    ]
  },
  {
    "code": "31-9096.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.12
      }
    ]
  },
  {
    "code": "31-9097.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.23
      }
    ]
  },
  {
    "code": "31-9099.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.5
      }
    ]
  },
  {
    "code": "31-9099.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.88
      }
    ]
  },
  {
    "code": "33-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.66
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.66
      }
    ]
  },
  {
    "code": "33-1012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.25
      }
    ]
  },
  {
    "code": "33-1021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.22
      }
    ]
  },
  {
    "code": "33-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.51
      }
    ]
  },
  {
    "code": "33-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.01
      }
    ]
  },
  {
    "code": "33-2022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.15
      }
    ]
  },
  {
    "code": "33-3011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.54
      }
    ]
  },
  {
    "code": "33-3012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.53
      }
    ]
  },
  {
    "code": "33-3021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.73
      }
    ]
  },
  {
    "code": "33-3021.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.34
      }
    ]
  },
  {
    "code": "33-3021.06",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.17
      }
    ]
  },
  {
    "code": "33-3031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.48
      }
    ]
  },
  {
    "code": "33-3041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.49
      }
    ]
  },
  {
    "code": "33-3051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.37
      }
    ]
  },
  {
    "code": "33-3051.04",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.27
      }
    ]
  },
  {
    "code": "33-3052.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3
      }
    ]
  },
  {
    "code": "33-9011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.21
      }
    ]
  },
  {
    "code": "33-9021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.26
      }
    ]
  },
  {
    "code": "33-9031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.01
      }
    ]
  },
  {
    "code": "33-9032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.37
      }
    ]
  },
  {
    "code": "33-9091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 0.58
      }
    ]
  },
  {
    "code": "33-9092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.69
      }
    ]
  },
  {
    "code": "33-9093.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.07
      }
    ]
  },
  {
    "code": "33-9099.02",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.7
      }
    ]
  },
  {
    "code": "35-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.28
      }
    ]
  },
  {
    "code": "35-1012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.44
      }
    ]
  },
  {
    "code": "35-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.46
      }
    ]
  },
  {
    "code": "35-2012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.54
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.01
      }
    ]
  },
  {
    "code": "35-2013.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.04
      }
    ]
  },
  {
    "code": "35-2014.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.81
      }
    ]
  },
  {
    "code": "35-2015.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.27
      }
    ]
  },
  {
    "code": "35-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.57
      }
    ]
  },
  {
    "code": "35-3011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.62
      }
    ]
  },
  {
    "code": "35-3023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.54
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.83
      }
    ]
  },
  {
    "code": "35-3023.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.91
      }
    ]
  },
  {
    "code": "35-3031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.38
      }
    ]
  },
  {
    "code": "35-3041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.53
      }
    ]
  },
  {
    "code": "35-9011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 0.99
      }
    ]
  },
  {
    "code": "35-9021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.27
      }
    ]
  },
  {
    "code": "35-9031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.21
      }
    ]
  },
  {
    "code": "37-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.54
      }
    ]
  },
  {
    "code": "37-1012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.68
      }
    ]
  },
  {
    "code": "37-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.61
      }
    ]
  },
  {
    "code": "37-2012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.02
      }
    ]
  },
  {
    "code": "37-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.39
      }
    ]
  },
  {
    "code": "37-3011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.76
      }
    ]
  },
  {
    "code": "37-3012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.06
      }
    ]
  },
  {
    "code": "37-3013.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.28
      }
    ]
  },
  {
    "code": "39-1013.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.84
      }
    ]
  },
  {
    "code": "39-1022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.71
      }
    ]
  },
  {
    "code": "39-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.99
      }
    ]
  },
  {
    "code": "39-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.54
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.3
      }
    ]
  },
  {
    "code": "39-3011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.99
      }
    ]
  },
  {
    "code": "39-3012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.5
      }
    ]
  },
  {
    "code": "39-3021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.66
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.49
      }
    ]
  },
  {
    "code": "39-3031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.08
      }
    ]
  },
  {
    "code": "39-3091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.19
      }
    ]
  },
  {
    "code": "39-3092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.29
      }
    ]
  },
  {
    "code": "39-3093.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.71
      }
    ]
  },
  {
    "code": "39-4011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.83
      }
    ]
  },
  {
    "code": "39-4021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.56
      }
    ]
  },
  {
    "code": "39-4031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.2
      }
    ]
  },
  {
    "code": "39-5011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.42
      }
    ]
  },
  {
    "code": "39-5012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.09
      }
    ]
  },
  {
    "code": "39-5091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.22
      }
    ]
  },
  {
    "code": "39-5092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.45
      }
    ]
  },
  {
    "code": "39-5093.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.57
      }
    ]
  },
  {
    "code": "39-5094.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 0.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.43
      }
    ]
  },
  {
    "code": "39-6011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.92
      }
    ]
  },
  {
    "code": "39-6012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.43
      }
    ]
  },
  {
    "code": "39-7011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.18
      }
    ]
  },
  {
    "code": "39-7012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.61
      }
    ]
  },
  {
    "code": "39-9011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.79
      }
    ]
  },
  {
    "code": "39-9011.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.32
      }
    ]
  },
  {
    "code": "39-9031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.76
      }
    ]
  },
  {
    "code": "39-9032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.14
      }
    ]
  },
  {
    "code": "39-9041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.19
      }
    ]
  },
  {
    "code": "41-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.57
      }
    ]
  },
  {
    "code": "41-1012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.58
      }
    ]
  },
  {
    "code": "41-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.84
      }
    ]
  },
  {
    "code": "41-2012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 0.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.88
      }
    ]
  },
  {
    "code": "41-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.37
      }
    ]
  },
  {
    "code": "41-2022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.95
      }
    ]
  },
  {
    "code": "41-2031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.98
      }
    ]
  },
  {
    "code": "41-3011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.29
      }
    ]
  },
  {
    "code": "41-3021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.59
      }
    ]
  },
  {
    "code": "41-3031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.25
      }
    ]
  },
  {
    "code": "41-3041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.28
      }
    ]
  },
  {
    "code": "41-4011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.69
      }
    ]
  },
  {
    "code": "41-4011.07",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.16
      }
    ]
  },
  {
    "code": "41-4012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.3
      }
    ]
  },
  {
    "code": "41-9011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.43
      }
    ]
  },
  {
    "code": "41-9012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.23
      }
    ]
  },
  {
    "code": "41-9021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.38
      }
    ]
  },
  {
    "code": "41-9022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4
      }
    ]
  },
  {
    "code": "41-9031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.1
      }
    ]
  },
  {
    "code": "41-9041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.14
      }
    ]
  },
  {
    "code": "41-9091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.42
      }
    ]
  },
  {
    "code": "43-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.61
      }
    ]
  },
  {
    "code": "43-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.86
      }
    ]
  },
  {
    "code": "43-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.47
      }
    ]
  },
  {
    "code": "43-3011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.61
      }
    ]
  },
  {
    "code": "43-3021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.66
      }
    ]
  },
  {
    "code": "43-3031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.56
      }
    ]
  },
  {
    "code": "43-3041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.92
      }
    ]
  },
  {
    "code": "43-3051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.77
      }
    ]
  },
  {
    "code": "43-3061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.76
      }
    ]
  },
  {
    "code": "43-3071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.34
      }
    ]
  },
  {
    "code": "43-4011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.94
      }
    ]
  },
  {
    "code": "43-4021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.76
      }
    ]
  },
  {
    "code": "43-4031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.9
      }
    ]
  },
  {
    "code": "43-4041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.76
      }
    ]
  },
  {
    "code": "43-4051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.38
      }
    ]
  },
  {
    "code": "43-4061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.16
      }
    ]
  },
  {
    "code": "43-4071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.1
      }
    ]
  },
  {
    "code": "43-4081.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.98
      }
    ]
  },
  {
    "code": "43-4111.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.6
      }
    ]
  },
  {
    "code": "43-4121.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.37
      }
    ]
  },
  {
    "code": "43-4131.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.67
      }
    ]
  },
  {
    "code": "43-4141.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.05
      }
    ]
  },
  {
    "code": "43-4151.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.15
      }
    ]
  },
  {
    "code": "43-4161.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.4
      }
    ]
  },
  {
    "code": "43-4171.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.71
      }
    ]
  },
  {
    "code": "43-4181.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.81
      }
    ]
  },
  {
    "code": "43-5011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.08
      }
    ]
  },
  {
    "code": "43-5011.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.31
      }
    ]
  },
  {
    "code": "43-5021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.65
      }
    ]
  },
  {
    "code": "43-5031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.54
      }
    ]
  },
  {
    "code": "43-5032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.38
      }
    ]
  },
  {
    "code": "43-5041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.85
      }
    ]
  },
  {
    "code": "43-5051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.18
      }
    ]
  },
  {
    "code": "43-5052.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.98
      }
    ]
  },
  {
    "code": "43-5053.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.08
      }
    ]
  },
  {
    "code": "43-5061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.06
      }
    ]
  },
  {
    "code": "43-5071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.72
      }
    ]
  },
  {
    "code": "43-5111.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.12
      }
    ]
  },
  {
    "code": "43-6011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.78
      }
    ]
  },
  {
    "code": "43-6012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.24
      }
    ]
  },
  {
    "code": "43-6013.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.21
      }
    ]
  },
  {
    "code": "43-6014.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.27
      }
    ]
  },
  {
    "code": "43-9021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.56
      }
    ]
  },
  {
    "code": "43-9022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.86
      }
    ]
  },
  {
    "code": "43-9031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.94
      }
    ]
  },
  {
    "code": "43-9041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.02
      }
    ]
  },
  {
    "code": "43-9051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.21
      }
    ]
  },
  {
    "code": "43-9061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.84
      }
    ]
  },
  {
    "code": "43-9071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.64
      }
    ]
  },
  {
    "code": "43-9081.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.69
      }
    ]
  },
  {
    "code": "43-9111.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 4.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 5.32
      }
    ]
  },
  {
    "code": "45-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.25
      }
    ]
  },
  {
    "code": "45-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.62
      }
    ]
  },
  {
    "code": "45-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.65
      }
    ]
  },
  {
    "code": "45-2041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.06
      }
    ]
  },
  {
    "code": "45-2091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.46
      }
    ]
  },
  {
    "code": "45-2092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.43
      }
    ]
  },
  {
    "code": "45-2093.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.03
      }
    ]
  },
  {
    "code": "45-3031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.98
      }
    ]
  },
  {
    "code": "45-4011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.3
      }
    ]
  },
  {
    "code": "45-4021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 1.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.35
      }
    ]
  },
  {
    "code": "45-4022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.12
      }
    ]
  },
  {
    "code": "45-4023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.26
      }
    ]
  },
  {
    "code": "47-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.74
      }
    ]
  },
  {
    "code": "47-1011.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.66
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.48
      }
    ]
  },
  {
    "code": "47-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.43
      }
    ]
  },
  {
    "code": "47-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.38
      }
    ]
  },
  {
    "code": "47-2022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.54
      }
    ]
  },
  {
    "code": "47-2031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.24
      }
    ]
  },
  {
    "code": "47-2041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.44
      }
    ]
  },
  {
    "code": "47-2042.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.99
      }
    ]
  },
  {
    "code": "47-2043.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.45
      }
    ]
  },
  {
    "code": "47-2044.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.27
      }
    ]
  },
  {
    "code": "47-2051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.93
      }
    ]
  },
  {
    "code": "47-2053.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.91
      }
    ]
  },
  {
    "code": "47-2061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.22
      }
    ]
  },
  {
    "code": "47-2071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.81
      }
    ]
  },
  {
    "code": "47-2072.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.55
      }
    ]
  },
  {
    "code": "47-2073.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.16
      }
    ]
  },
  {
    "code": "47-2081.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.12
      }
    ]
  },
  {
    "code": "47-2082.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.22
      }
    ]
  },
  {
    "code": "47-2111.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.66
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.63
      }
    ]
  },
  {
    "code": "47-2121.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.26
      }
    ]
  },
  {
    "code": "47-2131.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.23
      }
    ]
  },
  {
    "code": "47-2132.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.15
      }
    ]
  },
  {
    "code": "47-2141.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.92
      }
    ]
  },
  {
    "code": "47-2142.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.5
      }
    ]
  },
  {
    "code": "47-2151.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.12
      }
    ]
  },
  {
    "code": "47-2152.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.75
      }
    ]
  },
  {
    "code": "47-2152.04",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.1
      }
    ]
  },
  {
    "code": "47-2161.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.94
      }
    ]
  },
  {
    "code": "47-2171.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.63
      }
    ]
  },
  {
    "code": "47-2181.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.1
      }
    ]
  },
  {
    "code": "47-2211.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.84
      }
    ]
  },
  {
    "code": "47-2221.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.68
      }
    ]
  },
  {
    "code": "47-2231.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.15
      }
    ]
  },
  {
    "code": "47-3011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.63
      }
    ]
  },
  {
    "code": "47-3012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.59
      }
    ]
  },
  {
    "code": "47-3013.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.87
      }
    ]
  },
  {
    "code": "47-3014.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.74
      }
    ]
  },
  {
    "code": "47-3015.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.5
      }
    ]
  },
  {
    "code": "47-3016.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.26
      }
    ]
  },
  {
    "code": "47-4011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4
      }
    ]
  },
  {
    "code": "47-4011.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.31
      }
    ]
  },
  {
    "code": "47-4021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.11
      }
    ]
  },
  {
    "code": "47-4031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.01
      }
    ]
  },
  {
    "code": "47-4041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.98
      }
    ]
  },
  {
    "code": "47-4051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.7
      }
    ]
  },
  {
    "code": "47-4061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.28
      }
    ]
  },
  {
    "code": "47-4071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.91
      }
    ]
  },
  {
    "code": "47-4091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.13
      }
    ]
  },
  {
    "code": "47-4099.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.57
      }
    ]
  },
  {
    "code": "47-5011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.25
      }
    ]
  },
  {
    "code": "47-5012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.13
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.72
      }
    ]
  },
  {
    "code": "47-5013.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.19
      }
    ]
  },
  {
    "code": "47-5022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.6
      }
    ]
  },
  {
    "code": "47-5023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.12
      }
    ]
  },
  {
    "code": "47-5032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.04
      }
    ]
  },
  {
    "code": "47-5041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.79
      }
    ]
  },
  {
    "code": "47-5043.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.69
      }
    ]
  },
  {
    "code": "47-5044.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.89
      }
    ]
  },
  {
    "code": "47-5051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.45
      }
    ]
  },
  {
    "code": "47-5071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.25
      }
    ]
  },
  {
    "code": "47-5081.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.82
      }
    ]
  },
  {
    "code": "49-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.66
      }
    ]
  },
  {
    "code": "49-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.88
      }
    ]
  },
  {
    "code": "49-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.64
      }
    ]
  },
  {
    "code": "49-2022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.31
      }
    ]
  },
  {
    "code": "49-2091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.94
      }
    ]
  },
  {
    "code": "49-2092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.17
      }
    ]
  },
  {
    "code": "49-2093.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.33
      }
    ]
  },
  {
    "code": "49-2094.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.82
      }
    ]
  },
  {
    "code": "49-2095.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.74
      }
    ]
  },
  {
    "code": "49-2096.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.18
      }
    ]
  },
  {
    "code": "49-2097.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.36
      }
    ]
  },
  {
    "code": "49-2098.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.54
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.77
      }
    ]
  },
  {
    "code": "49-3011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.7
      }
    ]
  },
  {
    "code": "49-3021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.29
      }
    ]
  },
  {
    "code": "49-3022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.22
      }
    ]
  },
  {
    "code": "49-3023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.58
      }
    ]
  },
  {
    "code": "49-3031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.09
      }
    ]
  },
  {
    "code": "49-3041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.28
      }
    ]
  },
  {
    "code": "49-3042.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.48
      }
    ]
  },
  {
    "code": "49-3043.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.92
      }
    ]
  },
  {
    "code": "49-3051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.42
      }
    ]
  },
  {
    "code": "49-3052.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.34
      }
    ]
  },
  {
    "code": "49-3053.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.66
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.59
      }
    ]
  },
  {
    "code": "49-3091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.75
      }
    ]
  },
  {
    "code": "49-3092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.66
      }
    ]
  },
  {
    "code": "49-3093.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.7
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.57
      }
    ]
  },
  {
    "code": "49-9011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.3
      }
    ]
  },
  {
    "code": "49-9012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.81
      }
    ]
  },
  {
    "code": "49-9021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.11
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.54
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.06
      }
    ]
  },
  {
    "code": "49-9031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.86
      }
    ]
  },
  {
    "code": "49-9041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.1
      }
    ]
  },
  {
    "code": "49-9043.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3
      }
    ]
  },
  {
    "code": "49-9044.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.73
      }
    ]
  },
  {
    "code": "49-9045.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.57
      }
    ]
  },
  {
    "code": "49-9051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.99
      }
    ]
  },
  {
    "code": "49-9052.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.95
      }
    ]
  },
  {
    "code": "49-9061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.95
      }
    ]
  },
  {
    "code": "49-9062.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.02
      }
    ]
  },
  {
    "code": "49-9063.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.03
      }
    ]
  },
  {
    "code": "49-9064.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.89
      }
    ]
  },
  {
    "code": "49-9071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.93
      }
    ]
  },
  {
    "code": "49-9081.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.72
      }
    ]
  },
  {
    "code": "49-9091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.41
      }
    ]
  },
  {
    "code": "49-9092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.28
      }
    ]
  },
  {
    "code": "49-9094.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.95
      }
    ]
  },
  {
    "code": "49-9095.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.71
      }
    ]
  },
  {
    "code": "49-9096.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.56
      }
    ]
  },
  {
    "code": "49-9097.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.09
      }
    ]
  },
  {
    "code": "49-9098.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.48
      }
    ]
  },
  {
    "code": "49-9099.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.97
      }
    ]
  },
  {
    "code": "51-1011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.71
      }
    ]
  },
  {
    "code": "51-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.13
      }
    ]
  },
  {
    "code": "51-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.61
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.22
      }
    ]
  },
  {
    "code": "51-2022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.13
      }
    ]
  },
  {
    "code": "51-2023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.71
      }
    ]
  },
  {
    "code": "51-2031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.93
      }
    ]
  },
  {
    "code": "51-2041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.25
      }
    ]
  },
  {
    "code": "51-2051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.67
      }
    ]
  },
  {
    "code": "51-2061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.21
      }
    ]
  },
  {
    "code": "51-2092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.09
      }
    ]
  },
  {
    "code": "51-3011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.88
      }
    ]
  },
  {
    "code": "51-3021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.25
      }
    ]
  },
  {
    "code": "51-3022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.15
      }
    ]
  },
  {
    "code": "51-3023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.56
      }
    ]
  },
  {
    "code": "51-3091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.91
      }
    ]
  },
  {
    "code": "51-3092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.54
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.04
      }
    ]
  },
  {
    "code": "51-3093.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.31
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.93
      }
    ]
  },
  {
    "code": "51-4021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.94
      }
    ]
  },
  {
    "code": "51-4022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.66
      }
    ]
  },
  {
    "code": "51-4023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.51
      }
    ]
  },
  {
    "code": "51-4031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.83
      }
    ]
  },
  {
    "code": "51-4032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.84
      }
    ]
  },
  {
    "code": "51-4033.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.82
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.74
      }
    ]
  },
  {
    "code": "51-4034.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.83
      }
    ]
  },
  {
    "code": "51-4035.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.68
      }
    ]
  },
  {
    "code": "51-4041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.54
      }
    ]
  },
  {
    "code": "51-4051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.11
      }
    ]
  },
  {
    "code": "51-4052.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.76
      }
    ]
  },
  {
    "code": "51-4061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.93
      }
    ]
  },
  {
    "code": "51-4062.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.74
      }
    ]
  },
  {
    "code": "51-4071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.01
      }
    ]
  },
  {
    "code": "51-4072.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.85
      }
    ]
  },
  {
    "code": "51-4081.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.5
      }
    ]
  },
  {
    "code": "51-4111.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.81
      }
    ]
  },
  {
    "code": "51-4121.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.21
      }
    ]
  },
  {
    "code": "51-4122.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.25
      }
    ]
  },
  {
    "code": "51-4191.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.15
      }
    ]
  },
  {
    "code": "51-4192.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.18
      }
    ]
  },
  {
    "code": "51-4193.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.63
      }
    ]
  },
  {
    "code": "51-4194.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.89
      }
    ]
  },
  {
    "code": "51-5111.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.22
      }
    ]
  },
  {
    "code": "51-5112.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.17
      }
    ]
  },
  {
    "code": "51-5113.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.04
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.91
      }
    ]
  },
  {
    "code": "51-6011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.95
      }
    ]
  },
  {
    "code": "51-6021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 0.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.23
      }
    ]
  },
  {
    "code": "51-6031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.84
      }
    ]
  },
  {
    "code": "51-6041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.16
      }
    ]
  },
  {
    "code": "51-6042.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.79
      }
    ]
  },
  {
    "code": "51-6051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.8
      }
    ]
  },
  {
    "code": "51-6052.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.81
      }
    ]
  },
  {
    "code": "51-6061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.99
      }
    ]
  },
  {
    "code": "51-6062.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.8
      }
    ]
  },
  {
    "code": "51-6063.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.54
      }
    ]
  },
  {
    "code": "51-6064.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.02
      }
    ]
  },
  {
    "code": "51-6091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.05
      }
    ]
  },
  {
    "code": "51-6092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.98
      }
    ]
  },
  {
    "code": "51-6093.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.51
      }
    ]
  },
  {
    "code": "51-7011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.32
      }
    ]
  },
  {
    "code": "51-7021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2
      }
    ]
  },
  {
    "code": "51-7031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.81
      }
    ]
  },
  {
    "code": "51-7032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.2
      }
    ]
  },
  {
    "code": "51-7041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.54
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.94
      }
    ]
  },
  {
    "code": "51-7042.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.87
      }
    ]
  },
  {
    "code": "51-8011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.36
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.23
      }
    ]
  },
  {
    "code": "51-8012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.24
      }
    ]
  },
  {
    "code": "51-8013.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.05
      }
    ]
  },
  {
    "code": "51-8013.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.39
      }
    ]
  },
  {
    "code": "51-8013.04",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.66
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.52
      }
    ]
  },
  {
    "code": "51-8021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.53
      }
    ]
  },
  {
    "code": "51-8031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.33
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.21
      }
    ]
  },
  {
    "code": "51-8091.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.83
      }
    ]
  },
  {
    "code": "51-8092.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.54
      }
    ]
  },
  {
    "code": "51-8093.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.43
      }
    ]
  },
  {
    "code": "51-8099.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.11
      }
    ]
  },
  {
    "code": "51-9011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.84
      }
    ]
  },
  {
    "code": "51-9012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.23
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.95
      }
    ]
  },
  {
    "code": "51-9021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.29
      }
    ]
  },
  {
    "code": "51-9022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.35
      }
    ]
  },
  {
    "code": "51-9023.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.54
      }
    ]
  },
  {
    "code": "51-9031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.56
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.81
      }
    ]
  },
  {
    "code": "51-9032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.82
      }
    ]
  },
  {
    "code": "51-9041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.92
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.75
      }
    ]
  },
  {
    "code": "51-9051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.11
      }
    ]
  },
  {
    "code": "51-9061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.5
      }
    ]
  },
  {
    "code": "51-9071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.85
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.09
      }
    ]
  },
  {
    "code": "51-9071.06",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.21
      }
    ]
  },
  {
    "code": "51-9081.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.11
      }
    ]
  },
  {
    "code": "51-9082.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.17
      }
    ]
  },
  {
    "code": "51-9083.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.69
      }
    ]
  },
  {
    "code": "51-9111.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.12
      }
    ]
  },
  {
    "code": "51-9123.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.36
      }
    ]
  },
  {
    "code": "51-9124.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.59
      }
    ]
  },
  {
    "code": "51-9141.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.89
      }
    ]
  },
  {
    "code": "51-9151.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.04
      }
    ]
  },
  {
    "code": "51-9161.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.58
      }
    ]
  },
  {
    "code": "51-9162.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.07
      }
    ]
  },
  {
    "code": "51-9191.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.8
      }
    ]
  },
  {
    "code": "51-9192.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.05
      }
    ]
  },
  {
    "code": "51-9193.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.29
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.74
      }
    ]
  },
  {
    "code": "51-9194.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.82
      }
    ]
  },
  {
    "code": "51-9195.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.28
      }
    ]
  },
  {
    "code": "51-9195.03",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.65
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.52
      }
    ]
  },
  {
    "code": "51-9195.04",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.69
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.45
      }
    ]
  },
  {
    "code": "51-9195.05",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.34
      }
    ]
  },
  {
    "code": "51-9196.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.86
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.52
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.59
      }
    ]
  },
  {
    "code": "51-9197.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.18
      }
    ]
  },
  {
    "code": "51-9198.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.14
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.52
      }
    ]
  },
  {
    "code": "53-1041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.94
      }
    ]
  },
  {
    "code": "53-1042.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.41
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.98
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.2
      }
    ]
  },
  {
    "code": "53-1042.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.24
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.11
      }
    ]
  },
  {
    "code": "53-1043.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 4.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 5.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.74
      }
    ]
  },
  {
    "code": "53-2011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.43
      }
    ]
  },
  {
    "code": "53-2012.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.55
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.07
      }
    ]
  },
  {
    "code": "53-2021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 4.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 4.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.54
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.84
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.54
      }
    ]
  },
  {
    "code": "53-2022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.7
      }
    ]
  },
  {
    "code": "53-2031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.89
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.06
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.92
      }
    ]
  },
  {
    "code": "53-3011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.35
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.49
      }
    ]
  },
  {
    "code": "53-3031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.46
      }
    ]
  },
  {
    "code": "53-3032.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.66
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.39
      }
    ]
  },
  {
    "code": "53-3033.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.43
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.45
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.39
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.06
      }
    ]
  },
  {
    "code": "53-3052.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.48
      }
    ]
  },
  {
    "code": "53-4011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.23
      }
    ]
  },
  {
    "code": "53-4013.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.22
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.25
      }
    ]
  },
  {
    "code": "53-4022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.8
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.08
      }
    ]
  },
  {
    "code": "53-4031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.64
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.31
      }
    ]
  },
  {
    "code": "53-4041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.28
      }
    ]
  },
  {
    "code": "53-5011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.54
      }
    ]
  },
  {
    "code": "53-5021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 4.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.19
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.48
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.91
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.95
      }
    ]
  },
  {
    "code": "53-5022.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.93
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.78
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.71
      }
    ]
  },
  {
    "code": "53-5031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.94
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.34
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.19
      }
    ]
  },
  {
    "code": "53-6011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.53
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.47
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.25
      }
    ]
  },
  {
    "code": "53-6021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.18
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.44
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.24
      }
    ]
  },
  {
    "code": "53-6031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.76
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.87
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.1
      }
    ]
  },
  {
    "code": "53-6041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.99
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.09
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.32
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.02
      }
    ]
  },
  {
    "code": "53-6051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.57
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.21
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.94
      }
    ]
  },
  {
    "code": "53-6051.01",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 3.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 4.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.67
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.6
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 4.46
      }
    ]
  },
  {
    "code": "53-6051.07",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.95
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.16
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.28
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.21
      }
    ]
  },
  {
    "code": "53-6061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 4
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.37
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.72
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.96
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.55
      }
    ]
  },
  {
    "code": "53-7011.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 1.68
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 1.61
      }
    ]
  },
  {
    "code": "53-7021.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.91
      }
    ]
  },
  {
    "code": "53-7031.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.81
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.85
      }
    ]
  },
  {
    "code": "53-7041.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.63
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.13
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.71
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.26
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.23
      }
    ]
  },
  {
    "code": "53-7051.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.71
      }
    ]
  },
  {
    "code": "53-7061.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 0.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.9
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.79
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.46
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.9
      }
    ]
  },
  {
    "code": "53-7062.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.42
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.15
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.05
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.86
      }
    ]
  },
  {
    "code": "53-7062.04",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.59
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.34
      }
    ]
  },
  {
    "code": "53-7063.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 0.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.51
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.94
      }
    ]
  },
  {
    "code": "53-7064.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 0.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.25
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.77
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.73
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.6
      }
    ]
  },
  {
    "code": "53-7065.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.75
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.07
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.58
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 2.16
      }
    ]
  },
  {
    "code": "53-7071.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 3.83
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 4.17
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.38
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.21
      }
    ]
  },
  {
    "code": "53-7072.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.97
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 3.08
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.03
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.79
      }
    ]
  },
  {
    "code": "53-7073.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 1.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 1.62
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 2.49
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 3.02
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 3.19
      }
    ]
  },
  {
    "code": "53-7081.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 1.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 1.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 2.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.4
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.01
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.78
      }
    ]
  },
  {
    "code": "53-7121.00",
    "attributes": [
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.1",
        "scaleId": "LV",
        "dataValue": 3.38
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "IM",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.3",
        "scaleId": "LV",
        "dataValue": 3.25
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.a.4",
        "scaleId": "LV",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.4",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "IM",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.b.5",
        "scaleId": "LV",
        "dataValue": 2.88
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.1",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "IM",
        "dataValue": 2.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.c.2",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "IM",
        "dataValue": 3.62
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.e.3",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "IM",
        "dataValue": 2.75
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.1",
        "scaleId": "LV",
        "dataValue": 2
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "IM",
        "dataValue": 3
      },
      {
        "attributeType": "Ability",
        "elementId": "1.A.1.f.2",
        "scaleId": "LV",
        "dataValue": 3
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "IM",
        "dataValue": 3.25
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.a",
        "scaleId": "LV",
        "dataValue": 3.12
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "IM",
        "dataValue": 2.5
      },
      {
        "attributeType": "Skill",
        "elementId": "2.A.1.e",
        "scaleId": "LV",
        "dataValue": 2.12
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "IM",
        "dataValue": 2.1
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.1.a",
        "scaleId": "LV",
        "dataValue": 1.74
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "IM",
        "dataValue": 2.27
      },
      {
        "attributeType": "Knowledge",
        "elementId": "2.C.4.a",
        "scaleId": "LV",
        "dataValue": 1.75
      }
    ]
  }
]